/** SK Bridge logo glyph — the linked-arc mark from the source header. */
import React from 'react';
import Svg, { Path } from 'react-native-svg';

type Props = { size?: number; color?: string };

export default function BridgeMark({ size = 16, color = '#fff' }: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2.2} strokeLinecap="round">
      <Path d="M5 12h14" />
      <Path d="M5 12a4 4 0 0 1 4-4" />
      <Path d="M19 12a4 4 0 0 0-4-4" />
      <Path d="M5 12a4 4 0 0 0 4 4" />
      <Path d="M19 12a4 4 0 0 1-4 4" />
    </Svg>
  );
}
